import * as React from "react";
import { timeToString } from "../util/util";
/**
 * custom progress bar control, since the one from bootstrap isn't customizable
 * enough
 */
class ProgressBar extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            startTime: undefined,
            startPos: undefined,
        };
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.now !== newProps.now && this.state.startTime === undefined) {
            this.setState({ startTime: Date.now(), startPos: newProps.now });
        }
    }
    render() {
        const { className, labelLeft, labelRight, showPercentage, showTimeLeft, style, now, } = this.props;
        const min = this.props.min || 0;
        const max = this.props.max || 100;
        const percent = Math.floor(((now - min) / (max - min)) * 100);
        const hasLabel = labelLeft !== undefined || labelRight !== undefined;
        return (React.createElement("div", { className: (className || "") + " progressbar", style: style },
            React.createElement("div", { className: "progressbar-container" },
                hasLabel ? this.renderLabels() : null,
                React.createElement("div", { className: "progressbar-track" },
                    React.createElement("div", { className: "progressbar-progress", style: { width: `${percent}%` } }))),
            showPercentage ? this.renderPercentage(percent) : null,
            showTimeLeft ? this.renderTimeLeft(percent) : null));
    }
    renderLabels() {
        const { labelLeft, labelRight } = this.props;
        return (React.createElement("div", { className: "progressbar-labels" },
            React.createElement("div", null, labelLeft || ""),
            React.createElement("div", null, labelRight || "")));
    }
    renderPercentage(percent) {
        const percString = percent < 0 || percent > 100 ? "???" : `${percent}`;
        return React.createElement("div", { className: "progressbar-percentage" },
            percString,
            "%");
    }
    renderTimeLeft(percent) {
        const elapsed = Date.now() - this.state.startTime;
        if (Number.isNaN(elapsed) || percent === 0) {
            return null;
        }
        const expected = elapsed / (percent / 100);
        const timeString = elapsed < expected ? timeToString((expected - elapsed) / 1000) : "???";
        return React.createElement("div", { className: "progressbar-timeleft" }, timeString);
    }
}
export default ProgressBar;
